import { render, staticRenderFns } from "./categorypage.vue?vue&type=template&id=13feca0e"
import script from "./categorypage.vue?vue&type=script&lang=js"
export * from "./categorypage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports